import { GroupRegistrationText } from "@/constants/Schedule";
import { ModalTestID } from "@/constants/TestID";
import GroupClassSessionList from "@/ui/components/groupClasses/series/session/GroupClassSessionList";
import BottomSheetModal from "@/ui/composed/modal/BottomSheetModal";
import { Button, FAIconName } from "@/ui/core";
import { Box } from "@/ui/layout";
import type { GroupSessionCardItem } from "@/utils/groupClassV2.util";
import { joinTestIDs } from "@/utils/string.util";

interface EditGroupRegistrationBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onDismissAnimationEnd?: () => void;
  onSelectSession: (groupSectionId: string) => void;
  onUnregisterPress: () => void;
  sessions: GroupSessionCardItem[];
}

const baseTestID = ModalTestID.EditGroupRegistration;

const EditGroupRegistrationBottomSheet = ({
  isOpen,
  onClose,
  onDismissAnimationEnd,
  onSelectSession,
  onUnregisterPress,
  sessions,
}: EditGroupRegistrationBottomSheetProps) => (
  <BottomSheetModal
    dismissAccessibilityLabel="Dismiss Edit Registration"
    isOpen={isOpen}
    isScrollable
    onDismissAnimationEnd={onDismissAnimationEnd}
    onRequestClose={onClose}
    testID={baseTestID}
    title={GroupRegistrationText.EditRegistrationTitle}
  >
    <GroupClassSessionList
      description={GroupRegistrationText.AvailableSessionsDescription}
      footer={
        <Box paddingTop={16}>
          <Button
            isFullWidth
            leftIcon={FAIconName.UserSlash}
            onPress={onUnregisterPress}
            testID={joinTestIDs(baseTestID, "unregister")}
            title={GroupRegistrationText.UnregisterCta}
            variant="secondary"
          />
        </Box>
      }
      isInsideBottomSheet
      onSelect={onSelectSession}
      sessions={sessions}
    />
  </BottomSheetModal>
);

export default EditGroupRegistrationBottomSheet;
